import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';


const TopCell = styled('div', {
    shouldForwardProp: (prop) => prop !== 'rowHeight',
})(({ theme, rowHeight = 60 }) => ({
    zIndex: 8,
    position: 'sticky',
    top: 0,
    left: 0,
    height: rowHeight,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.dark,
    borderRight: `1px solid ${theme.palette.divider}`,
}));

const RowCell = styled('div', {
    shouldForwardProp: (prop) =>
        prop !== 'rowHeight' && prop !== 'isEven',
})(({ theme, rowHeight = 60, isEven }) => ({
    zIndex: 8,
    position: 'sticky',
    left: 0,
    height: rowHeight,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    backgroundColor: isEven
        ? theme.palette.neutral.light
        : theme.palette.background.dark,
    borderRight: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
    '& .MuiTypography-root': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
    },
}));


/* ======================
        LEFT PANEL
====================== */

const LeftPanel = ({
    syncY,
    topLeftScrollRef,
    topRightScrollRef,
    bottomLeftScrollRef,
    rowHeight = 50,
    headerName = "",
    fontSize = '0.75rem',
    data = [],
}) => {

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                backgroundColor: "background.default",
            }}
        >
            {/* HEADER */}
            <TopCell rowHeight={rowHeight} sx={{ flexShrink: 0 }}>
                <Typography
                    variant="body1"
                    noWrap
                    sx={{ width: '100%', textAlign: 'center' }}
                >
                    {headerName}
                </Typography>
            </TopCell>

            {/* BODY – SCROLL Y */}
            <Box
                ref={topLeftScrollRef}
                onScroll={(e) =>
                    syncY(e.target, [
                        topRightScrollRef.current,
                        bottomLeftScrollRef.current,
                    ])
                }
                sx={{
                    position: 'relative',
                    flexGrow: 1,
                    overflowX: 'hidden',
                    overflowY: 'scroll',
                    scrollbarWidth: 'none',
                    '&::-webkit-scrollbar': { display: 'none' },
                }}
            >
                {data?.map((row, idx) => (
                    <RowCell
                        key={row.id}
                        rowHeight={rowHeight}
                        isEven={idx % 2 === 0}
                        fontSize={fontSize}
                        sx={{ width: '100%' }}
                    >
                        <Typography variant="body2" fontSize={fontSize}>
                            {row.label}
                        </Typography>
                    </RowCell>
                ))}
            </Box>
        </Box>
    );
};

export default React.memo(LeftPanel);
